import React from "react";
import { Navbar, Nav, Container } from "react-bootstrap";

import "bootstrap/dist/css/bootstrap.min.css";
export const NavBar = () => {
  return (
    <Navbar bg="danger" variant="dark" expand="lg" fixed="top">
      <Container>
        <Navbar.Brand href="#home" className="logo">
          Mr. Parth Panchal
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link href="#home">Home</Nav.Link>
            <Nav.Link href="#skills">Skills</Nav.Link>
            <Nav.Link href="#project">Projects</Nav.Link>

            <Nav.Link href="#certificate">Certificate</Nav.Link>
            <Nav.Link href="#contact">Contact us</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};
